import styled, { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import Modal from '../../../components/Modal';
import { Heading4Text } from '../../../components/Texts';
import TextInput from '../../../components/Inputs/Text';
import Button from '../../../components/Button';
import { useNavigate } from 'react-router-dom';
import { useTokenSearch } from '../../../hooks/useTokenSearch';
import { hapticsImpactLight } from '../../../common/haptic';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../../common/responsive';
import TokenList from '../../../components/TokenList';

const SelectToken = ({
  onClose,
  title,
  onContinue,
  tokens = null, // Optional tokens array to restrict selection
  filterToken = null, // Optional token to exclude from selection
  disableUsdc = false,
  avoidClosing = false,
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);
  const theme = useTheme();
  const navigate = useNavigate();
  const displayTitle = title ?? t('selectTokenModal.defaultTitle');

  const {
    searchTerm,
    displayTokens,
    isLoading,
    isFetching,
    hasMore,
    setSearchTerm,
    loadMore,
  } = useTokenSearch(tokens, filterToken);

  const filteredTokens = displayTokens.filter(
    (token) => !(token.symbol === 'USDC' && disableUsdc),
  );

  const handleTokenSelect = (token) => {
    hapticsImpactLight();
    if (onContinue) {
      if (!avoidClosing) {
        onClose();
      }
      onContinue(token);
    } else {
      navigate(`/app/tokens/${token.address}`);
      onClose();
    }
  };

  return (
    <Modal
      onClose={onClose}
      customStyle={
        isMobile && {
          maxHeight: '95vh',
          height: '95vh',
          width: '100vw',
          borderRadius: '10px 10px 0px 0px',
        }
      }
      customOverlayStyle={isMobile ? { alignItems: 'flex-end' } : {}}
    >
      <div
        style={{
          display: 'flex',
          gap: 24,
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <div style={{ display: 'flex', gap: 15, flexDirection: 'column' }}>
          <Heading4Text
            style={{
              fontWeight: '600',
              marginTop: 20,
              color: theme.text.title,
            }}
          >
            {displayTitle}
          </Heading4Text>
          <TextInput
            placeholder={t('selectTokenModal.searchPlaceholder')}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <TokenList
          tokens={filteredTokens}
          isLoading={isLoading}
          isFetching={isFetching}
          hasMore={hasMore}
          loadMore={loadMore}
          onTokenSelect={handleTokenSelect}
          useFullHeight={false}
        />
        <div style={{ marginLeft: 'auto' }}>
          <Button variant='white' onClick={onClose}>
            {t('selectTokenModal.cancel')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SelectToken;
